import { Injectable } from '@angular/core';
import {
  HttpInterceptor,
  HttpRequest,
  HttpResponse,
  HttpHandler,
  HttpEvent,
  HttpErrorResponse,
} from '@angular/common/http';
import { environment } from '../../environments/environment';

import { Observable, throwError } from 'rxjs';
import { map, catchError } from 'rxjs/operators';

@Injectable()
export class BearerInterceptor implements HttpInterceptor {
  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    const token = localStorage.getItem('token');

    if (token) {
      const tokenData = JSON.parse(token);
      request = request.clone({
        headers: request.headers.set(
          'Authorization',
          'Bearer ' + tokenData.access_token
        ),
      });
    }

    if (
      !request.headers.has('Content-Type') &&
      [
        environment.apiUrl + '/v1/contacts/upload',
        environment.apiUrl + '/v1/contacts/upload-move',
      ].indexOf(request.url) === -1
    ) {
      request = request.clone({
        headers: request.headers.set('Content-Type', 'application/json'),
      });

      request = request.clone({
        headers: request.headers.set('Accept', 'application/json'),
      });
    }

    return next.handle(request).pipe(
      map((event: HttpEvent<any>) => {
        if (event instanceof HttpResponse) {
          console.log('event->>>>>', event);
        }

        return event;
      }),
      catchError((error: HttpErrorResponse) => {
        return throwError(error);
      })
    );
  }
}
